import type { AuthContextType } from "../types/authTypes";

import React from "react";

export const AuthProvider = React.createContext<AuthContextType>({} as AuthContextType)